// extracted by mini-css-extract-plugin
export default {"authButton":"Button-module__authButton___tIJow","facebook":"Button-module__facebook___PtYoO","apple":"Button-module__apple___UcTkB","google":"Button-module__google___mD0DM"};